import styled from '@emotion/styled';
import { keyframes } from '@emotion/core';
import { Text as BaseText } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';
import theme from 'styles/theme';

const target = keyframes`
  from { background: inherit; }
  50% { background: ${theme.colors.blue}; }
  to { background: inherit; }
`;

const Text = styled(BaseText)`
  :target {
    animation: ${target} 1s ease-out;
  }
`;

const BaseDisclaimer = (props) => <Text as="p" m={0} mb={5} color="greys.steel" fontSize="xs" {...props}></Text>;

BaseDisclaimer.displayName = 'BaseDisclaimer';

BaseDisclaimer.propTypes = {
  id: PropTypes.string.isRequired,
};

export default BaseDisclaimer;
